export default __webpack_public_path__ + "static/logo-black-98b7a1413b4a74ed961d292cf83da82e.svg";